var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-view",class:_vm.viewBackground ? 'white' : 'light-gray'},[_c('MdtNotify'),_c('MdtLightbox'),_c('UnprotectedViewHeader'),_c('div',{staticClass:"b2b-view-content"},[_c('RouterView',{staticClass:"b2b-view-router"})],1),_c('UnprotectedViewFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }